<script setup lang="ts">
import type { Product } from "@shopware-pwa/types";
import { Tint } from "~/components/clarity-ui/Tint";
import CommonLabel from "~/templates/components/CommonLabel.vue";
import { useExchangeBox } from "~/composables/shop/useExchangeBoxProduct";
import { useProductEShopSetConfigurator } from "~/composables/shop/useProductEShopSetConfigurator";

const props = defineProps<{
  product: Product;
}>();
const { product } = toRefs(props);

const { eShopSet, hasBestPrice, hasEShopSet } = await useProductEShopSetConfigurator();
const { isListPrice, unitPrice, price } = useProductPrice(product);
const { containsExchangeBox, amountCylinders } = await useExchangeBox();
</script>

<template>
  <div>
    <div v-if="unitPrice && !hasEShopSet" class="mt-2 flex items-baseline gap-2">
      <SharedPrice
        class="text-left text-base font-medium"
        :class="{ 'lg:text-3xl': isListPrice }"
        :discounted="isListPrice"
        :value="unitPrice"
      />
      <Tint v-if="isListPrice" class="text-sm"
        ><SharedPrice :value="price?.listPrice?.price" strikethrough
      /></Tint>
    </div>
    <Tint
      ><CommonLabel
        v-if="price && containsExchangeBox"
        class="text-sm"
        path="BWF/shop/exchangeBox/priceCardExchangeBoxHint"
        :placeholder="{ amountCylinders }"
    /></Tint>
    <template v-if="hasEShopSet">
      <div v-if="hasBestPrice" class="flex items-end gap-2">
        <SharedPrice
          class="mt-1 font-medium lg:mt-2 lg:text-3xl"
          discounted
          :value="eShopSet?.eshopSetPriceTotal"
        />
        <Tint
          ><SharedPrice
            class="mt-1 text-sm lg:mt-2"
            strikethrough
            :value="eShopSet?.bestEshopPriceFromHistory"
        /></Tint>
      </div>
      <SharedPrice v-else :value="eShopSet?.eshopSetPriceTotal" class="mt-1 font-medium lg:mt-2" />
    </template>
  </div>
</template>
